import React, { useEffect, useRef, useState } from "react";
import { Play, Pause, Waveform } from "@phosphor-icons/react";
import { fileUrl } from "../lib/api";

const BARS = [6, 12, 18, 10, 22, 14, 8, 20, 12, 16, 9, 19, 13, 7, 17, 11];

/** VoiceBubble — playable voice-clip chip used in DMs and comments. */
export default function VoiceBubble({ url, duration, title, mine = false, testid }) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => () => audioRef.current?.pause(), []);

  const toggle = () => {
    if (playing) { audioRef.current?.pause(); setPlaying(false); return; }
    if (!audioRef.current) {
      const a = new Audio(fileUrl(url));
      a.ontimeupdate = () => setProgress(a.duration ? a.currentTime / a.duration : 0);
      a.onended = () => { setPlaying(false); setProgress(0); };
      audioRef.current = a;
    }
    audioRef.current.play().then(() => setPlaying(true)).catch(() => {});
  };

  const secs = Math.round(duration || 0);
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testid}
      aria-pressed={playing}
      className={`flex items-center gap-2.5 px-3 py-2 rounded-2xl min-w-[190px] text-left ${mine ? "bg-papaya text-ink" : "bg-white/10 text-cream border border-white/10"}`}
    >
      <span className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${mine ? "bg-ink/15" : "bg-papaya text-ink"}`}>
        {playing ? <Pause size={13} weight="fill" /> : <Play size={13} weight="fill" />}
      </span>
      <span className="flex items-end gap-[2px] h-6 flex-1" aria-hidden>
        {BARS.map((h, i) => (
          <span
            key={i}
            className={`w-[3px] rounded-full ${i / BARS.length <= progress ? (mine ? "bg-ink" : "bg-papaya") : (mine ? "bg-ink/35" : "bg-cream/30")} ${playing ? "animate-pulse" : ""}`}
            style={{ height: `${h}px` }}
          />
        ))}
      </span>
      <span className="flex flex-col items-end flex-shrink-0">
        <span className="text-[11px] font-black tabular-nums">{secs ? `${secs}s` : <Waveform size={12} />}</span>
        {title && <span className={`text-[9px] truncate max-w-[90px] ${mine ? "text-ink/70" : "text-cream/50"}`}>{title}</span>}
      </span>
    </button>
  );
}
